import React from 'react'
import Head from 'next/head'
import dynamic from 'next/dynamic'

const Footer = dynamic(import('@/components/home/footer'))
const KPHead = dynamic(import('@/components/head'))
const TopNavigation = dynamic(import('@/components/top-navigation'))

import styled from 'styled-components'
import { Animation, Reveal } from 'react-genie'


const Riplay = () => {

  return (
    <RiplayStyle>
      <Reveal animation={Animation.FadeIn}>
        <KPHead metaTitle="riplay" />
        <TopNavigation />
        <div className="attention">
          <h2 className="title">Ringkasan Informasi Produk dan Layanan (RIPLAY)</h2>
          <div className='section'>
            <p>Ringkasan Informasi Produk dan/atau Layanan (RIPLAY) adalah dokumen atau sarana lain yang memuat karakteristik dan informasi penting atau utama mengenai produk dan/atau layanan jasa keuangan.</p>
            <p>RIPLAY bertujuan agar dapat meningkatkan efektivitas transparansi dan keterbukaan informasi kepada Konsumen.</p>
          </div>
          <h2 className="title">PT Kredit Pintar Indonesia</h2>
          <div className='section'>
            <p>PT Kredit Pintar Indonesia adalah perusahaan fintech (financial technology) yang berizin dan diawasi oleh Otoritas Jasa Keuangan (OJK). PT Kredit Pintar Indonesia memiliki visi untuk meningkatkan kehidupan masyarakat Indonesia melalui penyediaan akses yang mudah untuk mendapatkan pinjaman jangka pendek. Dan dengan teknologi AI (Artificial Intelligence) terdepan, PT Kredit Pintar Indonesia berharap bekerja sama dengan masyarakat untuk meningkatkan kesejahteraan Indonesia. </p>
          </div>
          <h2 className="title">Produk dan Fitur Utama</h2>
          <div className='section'>
            <p>Nama Produk : Kredit Pintar</p>
            <p>Tipe Produk : Pinjaman dana tunai tanpa agunan</p>
            <p>Mata uang : Rupiah (IDR)</p>
            <p>Diskripsi produk : Kredit Pintar adalah aplikasi penyedia layanan pinjaman meminjam tanpa agunan melalui aplikasi perangkat selular untuk memenuhi kebutuhan dana tunai dengan mudah dan cepat. </p>
          </div>
          <h2 className="title">Batas Pinjaman</h2>
          <div className='section'>
            <p>Nominal batas pinjaman tersedia mulai dari Rp 600.000,- hingga Rp 50.000.000,-</p>
          </div>
          <h2 className="title">Jangka Waktu Pinjaman</h2>
          <div className='section'>
            <p>2, 3, 6 atau 12 bulan.</p>
          </div>
          <h2 className="title">Manfaat Ekonomi </h2>
          <div className='section'>
            <p>Manfaat ekonomi yang dibebankan maksimal 0.3% flat per hari meliputi bunga dan biaya lain selain denda keterlambatan, bea meterai, dan pajak. </p>
          </div>
          <h2 className="title">Agunan</h2>
          <div className='section'>
            <p>Tanpa Agunan</p>
          </div>
          <h2 className="title">Manfaat</h2>
          <div className='section'>
            <p>Kredit Pintar dapat dimanfaatkan oleh pengguna untuk pemenuhan berbagai kebutuhan, baik kebutuhan produktif maupun konsumtif dengan proses pengajuan yang mudah dan cepat.</p>
          </div>
          <h2 className="title">Risiko</h2>
          <div className='section'>
            <p>Bagi pengguna yang tidak menyelesaikan kewajibannya ada risiko yang ditanggung oleh nasabah seperti: </p>
            <div className='list'>
              <span>1.</span>
              <div>Terjadinya biaya tambahan yang harus dibayarkan oleh nasabah akibat keterlambatan</div>
            </div>
            <div className='list'>
              <span>2.</span>
              <div>Menjadi catatan buruk nasabah di laporan regulator</div>
            </div>
          </div>
          <h2 className="title">Biaya</h2>
          <div className='section'>
            <p>Biaya yang muncul dalam pinjaman antara lain:</p>
            <div className='list'>
              <span>1.</span>
              <div>Biaya Jasa Pemberi Dana</div>
            </div>
            <div className='list'>
              <span>2.</span>
              <div>Biaya Jasa Layanan</div>
            </div>
            <div className='list'>
              <span>3.</span>
              <div>Biaya Jasa Pembayaran</div>
            </div>
            <div className='list'>
              <span>4.</span>
              <div>Biaya denda keterlambatan</div>
            </div>
            <p>Untuk Biaya Jasa Pemberi Dana, Jasa Layanan, dan Jasa Pembayaran, akan masuk ke dalam bunga dan manfaat ekonomi.</p>
            <p>Biaya denda keterlambatan maksimal 0.3% per hari dan tidak akan melebihi 100% dari pokok pinjaman.</p>
          </div>
          <h2 className="title">Persyaratan dan Tata Cara</h2>
          <h3 className='tit'>Persyaratan Pengguna</h3>
          <div className='section'>
            <div className='list'>
              <span>1.</span>
              <div>Tercatat sebagai Warga Negara Indonesia.</div>
            </div>
            <div className='list'>
              <span>2.</span>
              <div>Usia diantara 18-60 tahun (*60 tahun pada saat jatuh tempo pinjaman).</div>
            </div>
            <div className='list'>
              <span>3.</span>
              <div>Memiliki KTP yang masih berlaku.</div>
            </div>
            <div className='list'>
              <span>4.</span>
              <div>Memiliki akun Bank sesuai dengan data KTP.</div>
            </div>
            <div className='list'>
              <span>5.</span>
              <div>Berdomisili di Indonesia.</div>
            </div>
            <div className='list'>
              <span>6.</span>
              <div>Memenuhi dokumen dan Data lain yang diperlukan.</div>
            </div>
          </div>
          <h3 className='tit'>Cara Melakukan Pinjaman</h3>
          <div className='section'>
            <div className='list'>
              <span>1.</span>
              <div>Unduh aplikasi Kredit Pintar melalui Google Play Store atau Apple Store.</div>
            </div>
            <div className='list'>
              <span>2.</span>
              <div>Lakukan registrasi di aplikasi Kredit Pintar dan isi data diri sesuai dengan keadaan sesungguhnya. Sebaliknya apabila tidak mengisi dengan data sesungguhnya dapat berujung ke penolakan pinjaman dan merusak reputasi peminjam di mata pemberi pinjaman dan lembaga keuangan lainnya.</div>
            </div>
            <div className='list'>
              <span>3.</span>
              <div>Ajukan pinjaman sesuai dengan pilihan nominal yang tersedia.</div>
            </div>
            <div className='list'>
              <span>4.</span>
              <div>Tunggu persetujuan pengajuan pinjaman.</div>
            </div>
            <div className='list'>
              <span>5.</span>
              <div>Dana akan cair ke rekening setelah persetujuan pinjaman diterima dan nasabah melakukan tandatangan perjanjian.</div>
            </div>
          </div>
          <h3 className='tit'>Pengaduan Terkait Produk dan Layanan</h3>
          <div className='section'>
            <div className='list'>
              <span className='circle'></span>
              <div>Email ke cs@kreditpintar.com</div>
            </div>
            <div className='list'>
              <span className='circle'></span>
              <div>Hotline di (021) 50598882</div>
            </div>
            <div className='list'>
              <span className='circle'></span>
              <div>Jam operasional: 08:00-17:00 WIB (Senin-Minggu)</div>
            </div>
            <div className='list'>
              <span className='circle'></span>
              <div>Kantor Operasional Layanan Pelanggan: Mandiri In Health Tower Lt. 3, Jl. Prof. DR. Satrio Kav. E-IV No.6, Kuningan, Karet Kuningan, Kecamatan Setiabudi, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12940</div>
            </div>
            <div className='list'>
              <span className='circle'></span>
              <div>Website: kreditpintar.com</div>
            </div>
          </div>
          <h3 className='tit'>Simulasi</h3>
          <table>
            <tr>
              <td>Nilai Pinjaman</td>
              <td>Rp 8.000.000</td>
            </tr>
            <tr>
              <td>Tenor</td>
              <td>12 bulan</td>
            </tr>
            <tr>
              <td>Bunga (0.13%/hari)</td>
              <td>Rp 3.984.268</td>
            </tr>
            <tr>
              <td>Biaya Layanan (0.016%/hari)</td>
              <td>Rp 455.731</td>
            </tr>
            <tr>
              <td>Pajak Pertambahan Nilai (11% dari biaya layanan per bulan)</td>
              <td>Rp 50.124</td>
            </tr>
            <tr>
              <td>Nilai Uang yang Diterima Peminjam</td>
              <td>Rp 7.480.000</td>
            </tr>
            <tr>
              <td>Cicilan per Bulan</td>
              <td>Rp 1.040.844</td>
            </tr>
            <tr>
              <td>Total Pembayaran Pinjaman Kembali 12 bulan</td>
              <td>Rp 12.490.123</td>
            </tr>
          </table>
          <div className='section'>
            <p>Pembayaran pertama akan jatuh tempo setelah 30 hari dari tanggal pinjaman disetujui, demikian juga untuk pembayaran kedua, ketiga, dan seterusnya.</p>
            <p className='sub-title'>Contoh:</p>
            <div className='list'>
              <span className='circle'></span>
              <div>Mengajukan pinjaman dan disetujui pada tanggal <b>25 Maret</b></div>
            </div>
            <div className='list'>
              <span className='circle'></span>
              <div>Jatuh tempo pembayaran pertama <b>: 25 April</b></div>
            </div>
            <div className='list'>
              <span className='circle'></span>
              <div>Jatuh tempo pembayaran kedua <b>: 25 Mei</b></div>
            </div>
            <div className='list'>
              <span className='circle'></span>
              <div>Jatuh tempo pembayaran ketiga <b>: 25 Juni</b>, dst.</div>
            </div>
          </div>
          <h2 className="title">Informasi Tambahan</h2>
          <h3 className='tit'>Disclaimer (Penting untuk dibaca)</h3>
          <div className='section'>
            <div className='list'>
              <span>1.</span>
              <div>Informasi yang tercakup dalam RIPLAY Umum ini adalah ketentuan terbaru sampai dengan diterbitkannya RIPLAY Umum yang lebih baru, dan Kredit Pintar berhak memperbarui informasi yang tercantum pada RIPLAY Umum ini sewaktu-waktu. </div>
            </div>
            <div className='list'>
              <span>2.</span>
              <div>RIPLAY Umum ini hanya digunakan sebagai referensi untuk memberikan penjelasan mengenai produk pinjaman tunai dan bukan merupakan suatu perjanjian pinjaman yang mengikat. </div>
            </div>
            <div className='list'>
              <span>3.</span>
              <div>Kredit Pintar berhak menolak permohonan Pengguna atas pengajuan pinjaman dana tunai apabila tidak memenuhi persyaratan dan peraturan yang berlaku.</div>
            </div>
          </div>
        </div>
        <Footer />
      </Reveal>
    </RiplayStyle>
  )
}

export default Riplay

const RiplayStyle = styled.div`
  width: 100%;
  min-height: 30vh;
  color: #1f2329;
  p {
    margin: 4px 0;
  }
  table {
    margin: 16px 0;
  }
  table, tr, td {
    border-collapse: collapse;
    border: 1px solid #000;
    padding: 10px;
  }
  .sub-title {
    font-size: 18px;
    font-weight: 900;
  }
  b {
    font-weight: 900 !important;
  }
  @media only screen and (max-width: 1000px) {
    .attention {
      margin: 0 auto;
      padding: 78px 24px 16px;
      .title {
        margin: 12px 0 6px;
        font-size: 24px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
        line-height: 28px;
      }
      .tit {
        margin: 12px 0 6px;
        font-size: 22px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
        line-height: 32px;
      }
      .section {
        font-size: 16px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        line-height: 24px;
        .list {
          display: flex;
          margin: 4px 0;
          span {
            margin-right: 8px;
            color: #007aff;
            font-family: Roboto-Regular, Roboto;
            font-size: 14px;
          }
          .circle {
            display: inline-block;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            margin-right: 14px;
            background-color: #007aff;
            flex: none;
            position: relative;
            top: 10px;
          }
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    .attention {
      max-width: 1140px;
      margin: 0 auto;
      padding: 82px 0;
      .title {
        margin: 12px 0 6px;
        font-size: 26px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
        line-height: 42px;
        &:first-child {
          margin-top: 42px;
        }
      }
      .tit {
        margin: 12px 0 6px;
        font-size: 22px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
        line-height: 32px;
      }
      .section {
        font-size: 16px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        line-height: 24px;
        .list {
          display: flex;
          margin: 4px 0;
          span {
            margin-right: 8px;
            color: #007aff;
            font-family: Roboto-Regular, Roboto;
            font-size: 14px;
          }
          .circle {
            display: inline-block;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            margin-right: 14px;
            background-color: #007aff;
            flex: none;
            position: relative;
            top: 10px;
          }
        }
      }
    }
  }
`
